// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"61":"Money","111":"DemoItem"}[chunkId] || chunkId) + "." + {"61":"7b16e57c","98":"46fea9a8","111":"bc58a85d","659":"68ce9343"}[chunkId] + ".js";
};